export const IMAGE_CONSTANTS = {
    PREVIEW_IMAGE_SIZE: 250,
    MAX_BLOB_SIZE: 1 * 1024 * 1024,
    IMAGE_SIZE_THRESHOLD: 1024 * 1024,
    PUBLISH_IMAGE_QUALITY: 0.8,
    PREVIEW_IMAGE_QUALITY: 0.7,
    IMG_STORE_HEIGHT: 800,
    IMG_STORE_WIDTH: 600
}



// WEBPACK FOOTER //
// ./src/constants/image.ts